import React, { Component } from 'react';
import http from '../modules/api';
import Button from '../modules/common/Button'; // 경로는 프로젝트에 맞게 조정
import {RpAutoConfigIntro} from './RpAutoConfigIntro';
import ProductCategorySelector from './ProductCategorySelector';
import CustomerAcquisitionSelector from './CustomerAcquisitionSelector';
import {RpAutoAlgorithmTable} from './RpAutoAlgorithmTable';
import WarningDialog from '../modules/dialogs/WarningDialog';
import {RpCafe24ClonePopupByRpCategoryMethod} from './RpCafe24ClonePopupByRpCategoryMethod';

class ParentAutoRpSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step:"",
            selected_category_cd: "",
            selected_method_cd: "",
            filter_page_id: "",
            template_id: "",
        }
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        if (params.get("category_cd") && params.get("method_cd")) {
            this.setState({
                selected_category_cd: params.get("category_cd"),
                selected_method_cd: params.get("method_cd"),
                step: 3,
            });
        } else {
            this.handleLoadCategoryMethod();
        }
    }

    // 사용자의 키워드 저장 (POST)
    handleSaveCategoryMethod = () => {
        const { selected_category_cd, selected_method_cd } = this.state;

        http.post('/rest/shop/rp/user-category-method', {
            category_cd: selected_category_cd,
            method_cd: selected_method_cd
        }, {
        headers: {
            'Content-Type': 'application/json'
        }
        })
        .then(res => {
        if (res.data.code === 200) {
            console.console('키워드 저장 성공');
        } 
        })
        .catch(err => {
        console.error('키워드 저장 에러:', err);
        });
    }

    // 사용자의 키워드 조회 (GET)
    handleLoadCategoryMethod = () => {
        http.get('/rest/shop/rp/user-category-method')
        .then(res => {
        if (res.data.code == 200) {
            const params = new URLSearchParams(window.location.search);
            let filter_page_id = "";
            let template_type_cd = "";
            if (params.get("filter_page_id")) {
                /* URL 파라미터에 따른 디폴트 */
                filter_page_id = params.get("filter_page_id");
            }
            if (params.get("template_type_cd")) {   
                template_type_cd = params.get("template_type_cd");
            }
            this.setState({
                temp_selected_category_cd: res.data.category_cd || "",
                selected_category_cd: res.data.category_cd || "",
                temp_selected_method_cd: res.data.method_cd || "",
                selected_method_cd: res.data.method_cd || "",
                step: res.data.category_cd && res.data.method_cd ? 3 : 0,
                filter_page_id: filter_page_id,
                template_type_cd: template_type_cd,
            });
        } else {
            this.setState({
                step: 0,
            });
        }
        })
        .catch(err => {
        console.error('키워드 조회 에러:', err);
        this.setState({
            step: 0,
        });
        });
    }

    onClickCategorySelectButton(selected_code_cd) {
        this.setState({
            temp_selected_category_cd: selected_code_cd,
        });
    }

    onClickMethodSelectButton(selected_code_cd) {
        this.setState({
            temp_selected_method_cd: selected_code_cd,
        });
    }

    onClickNextButton(selected_code_cd) {
        // console.log("selected_code_cd", selected_code_cd);
        if (selected_code_cd) {
            if (this.state.step == 1) {
                this.setState({
                    temp_selected_category_cd: selected_code_cd,
                    step:2
                });
            } else if (this.state.step == 2) {
                this.setState({
                    temp_selected_method_cd: selected_code_cd,
                    step:3,

                    selected_category_cd: this.state.temp_selected_category_cd,
                    selected_method_cd: selected_code_cd,
                }, () => {
                    this.handleSaveCategoryMethod();
                });
            }
        } else {
            this.setState({
                step: this.state.step + 1
            });
        }
    }

    onClickRegistButton(template_id, iframe_page_id, cafe24_category_display_group, targetCloneObj) {
        // console.log("template_id", template_id);
        this.setState({
            template_id: template_id,
            iframe_page_id: iframe_page_id,
            cafe24_category_display_group: cafe24_category_display_group,
            targetCloneObj: targetCloneObj,
            showClonePopup: true,
        }, () => {
            
        });
    }

    async onClickSettingButton(type) {
        if (type > 1) {
            await this.getStoreCategoryList();
        }
        if (type > 2) {
            await this.getStoreMethodList();
        }
        await this.setState({
            step: type,
        });
    }

    async getStoreCategoryList() {
        try {
            const res = await http.get("/rest/shop/rp/storeCategory/list?start_idx=0&row_cnt=1");
            if (res.data && res.data.list?.length > 0) {
                const categories = res.data.list;
                this.setState({
                    temp_selected_category_cd: categories[0].category_cd,
                    selected_category_cd: categories[0].category_cd
                });
            }
        } catch (error) {
            // 에러 처리
        }
    }
    
    async getStoreMethodList() {
        try {
            const res = await http.get("/rest/shop/rp/customerMethod/list?start_idx=0&row_cnt=1"
                + "&category_cd=" + this.state.temp_selected_category_cd
            );
            if (res.data && res.data.list?.length > 0) {
                const methods = res.data.list;
                this.setState({
                    temp_selected_method_cd: methods[0].method_cd,
                    selected_method_cd: methods[0].method_cd
                });
            }
        } catch (error) {
            // 에러 처리
        }
    }

  render() {
    let {step, temp_selected_category_cd, temp_selected_method_cd, selected_category_cd, selected_method_cd, filter_page_id, template_type_cd} = this.state;
    return (
        <div id='common-page-wrapper' className="style_guide_v2" style={{width: "100%", height: "100%", position: "absolute"}}>
            {
                step !== ""
                ? 
                    step == 0
                    ?   <RpAutoConfigIntro 
                            onClick={this.onClickNextButton.bind(this)}
                            onClickSettingButton={this.onClickSettingButton.bind(this)}
                        />
                    :   <>
                            <div className="auto-setting-header">
                                <div className="flexBox page-title">
                                    <h1 className="title">AI자동설정</h1>
                                    <span className="description">
                                        AI자동설정을 하시면 쇼핑몰페이지마다 상품노출효과 진열순서를 고객 행동 데이터에 맞춰서 자동진열되게 볼 수 있습니다
                                    </span>
                                </div>
                                <div className="step-tracker">
                                    <span className={"step" + (step == 1 ? ' active' : '')} onClick={() => this.setState({step:1})}>
                                        판매상품분석
                                        <span className="line"></span>    
                                    </span>
                                    <span className="arrow">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.2497 12.0003C17.247 12.1991 17.1701 12.3897 17.0341 12.5346L9.5341 20.0346C9.38838 20.1542 9.20338 20.2154 9.01509 20.2061C8.8268 20.1969 8.64869 20.1179 8.51539 19.9846C8.38208 19.8513 8.30313 19.6732 8.29388 19.4849C8.28464 19.2966 8.34576 19.1116 8.46535 18.9659L15.4404 12.0003L8.46535 5.03465C8.34576 4.88893 8.28464 4.70393 8.29389 4.51564C8.30313 4.32735 8.38209 4.14923 8.51539 4.01593C8.64869 3.88263 8.82681 3.80368 9.0151 3.79443C9.20339 3.78518 9.38838 3.8463 9.5341 3.9659L17.0341 11.4659C17.1701 11.6109 17.247 11.8015 17.2497 12.0003Z" fill="#808080" fill-opacity="0.55"/>
                                        </svg>
                                    </span>
                                    <span className={"step" + (step == 2 ? ' active' : '')} 
                                        onClick={() => {
                                            if (!temp_selected_category_cd) {
                                                this.setState({
                                                    show_warning_dialog: true  
                                                })
                                            } else {
                                                this.setState({
                                                    step:2
                                                }, () => {
                                                    this.handleSaveCategoryMethod();
                                                })
                                            }
                                        }}
                                    >
                                        성장단계분석
                                        <span className="line"></span>    
                                    </span>
                                    <span className="arrow">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.2497 12.0003C17.247 12.1991 17.1701 12.3897 17.0341 12.5346L9.5341 20.0346C9.38838 20.1542 9.20338 20.2154 9.01509 20.2061C8.8268 20.1969 8.64869 20.1179 8.51539 19.9846C8.38208 19.8513 8.30313 19.6732 8.29388 19.4849C8.28464 19.2966 8.34576 19.1116 8.46535 18.9659L15.4404 12.0003L8.46535 5.03465C8.34576 4.88893 8.28464 4.70393 8.29389 4.51564C8.30313 4.32735 8.38209 4.14923 8.51539 4.01593C8.64869 3.88263 8.82681 3.80368 9.0151 3.79443C9.20339 3.78518 9.38838 3.8463 9.5341 3.9659L17.0341 11.4659C17.1701 11.6109 17.247 11.8015 17.2497 12.0003Z" fill="#808080" fill-opacity="0.55"/>
                                        </svg>
                                    </span>
                                    <span className={"step" + (this.state.step == 3 ? ' active' : '')} 
                                        onClick={() => {
                                            if (!temp_selected_method_cd) {
                                                this.setState({
                                                    show_warning_dialog: true  
                                                })
                                            } else {
                                                this.setState({
                                                    selected_category_cd: temp_selected_category_cd,
                                                    selected_method_cd: temp_selected_method_cd,
                                                    step:3
                                                }, () => {
                                                    this.handleSaveCategoryMethod();
                                                });
                                            }
                                        }}
                                    >
                                        자동진열위치
                                        <span className="line"></span>    
                                    </span>
                                </div>
                            </div>
                            <div className='ParentAutoRpSettingContents'>
                            {
                                step == 1
                                ? <ProductCategorySelector 
                                    onClicktCategorySelectButton={this.onClickCategorySelectButton.bind(this)}
                                    onClickNextButton={this.onClickNextButton.bind(this)}
                                    onPageChange={(pageNumber) => {this.setState({categoryActivePage: pageNumber})}}
                                    activePage={this.state.categoryActivePage}
                                    selected_category_cd = {temp_selected_category_cd}
                                />
                                :   step == 2 
                                    ? <CustomerAcquisitionSelector 
                                        onClickMethodSelectButton={this.onClickMethodSelectButton.bind(this)}
                                        onClickNextButton={this.onClickNextButton.bind(this)}
                                        onPageChange={(pageNumber) => {this.setState({methodActivePage: pageNumber})}}
                                        activePage={this.state.methodActivePage}
                                        selected_method_cd = {temp_selected_method_cd}
                                        selected_category_cd= {temp_selected_category_cd}
                                    />
                                    :   step == 3
                                        ? <RpAutoAlgorithmTable
                                            category_cd = {selected_category_cd}
                                            method_cd = {selected_method_cd}
                                            filter_page_id={filter_page_id}
                                            template_type_cd={template_type_cd}
                                            onClickRegistButton={this.onClickRegistButton.bind(this)}
                                        />
                                        : <div style={{width: "100%", height: "100%"}}></div>
                            }
                            </div>
                            {
                                this.state.show_warning_dialog
                                && <WarningDialog
                                    content={"항목을 선택해 주새요."}
                                    button_list={[{
                                        title : "확인",
                                        event_method : () => { this.setState({show_warning_dialog: false}) }
                                    }]}
                                />
                            }
                            {this.state.showClonePopup &&
                                <RpCafe24ClonePopupByRpCategoryMethod
                                    org_event_setting_obj={this.state.targetCloneObj}
                                    onClose={() => this.setState({ showClonePopup: false, targetCloneObj: null })}
                                    iframe_page_id={this.state.iframe_page_id}
                                    cafe24_category_display_group={this.state.cafe24_category_display_group}
                                    is_check_not_modify_5 = {true}
                                    is_check_not_modify_6 = {true}
                                />
                            }
                        </>
                :   <></>        
            }
        </div>
    );
  }
}

export default ParentAutoRpSetting;